import app from 'flarum/forum/app';

/* ============ 网盘品牌库（对齐 emlog PanBox 31+ 网盘） ============ */
const NETDISK_TYPES = [
  { name: '百度网盘', keywords: ['pan.baidu.com', 'yun.baidu.com'], color: '#306cff' },
  { name: '夸克网盘', keywords: ['pan.quark.cn'], color: '#6a5acd' },
  { name: '阿里云盘', keywords: ['alipan.com', 'aliyundrive.com', 'alipan.cn'], color: '#ff6a00' },
  { name: '蓝奏云', keywords: ['lanzou.com', 'lanzouw.com', 'lanzoui.com', 'lanzout.com', 'lanzouo.com', 'lanzoup.com', 'lanzous.com', 'lanzouy.com', 'lanzoux.com', 'lanzouj.com'], color: '#2196f3' },
  { name: '123网盘', keywords: ['123pan.com', '123pan.cn'], color: '#07c160' },
  { name: '迅雷网盘', keywords: ['pan.xunlei.com', 'xunlei.com'], color: '#00b4ff' },
  { name: '115网盘', keywords: ['115.com', '115cdn.com'], color: '#2d8cf0' },
  { name: '天翼云盘', keywords: ['cloud.189.cn', '189cloud.com'], color: '#00b4ff' },
  { name: '移动云盘', keywords: ['yun.139.com', 'caiyun.139.com'], color: '#0099ff' },
  { name: '联通云盘', keywords: ['pan.wo.cn'], color: '#e60012' },
  { name: '城通网盘', keywords: ['ctfile.com', 'ctfile.cn', '545c.com'], color: '#ff6600' },
  { name: '奶牛快传', keywords: ['cowtransfer.com', 'cowsend.com'], color: '#ff6600' },
  { name: '文叔叔', keywords: ['wenshushu.cn'], color: '#4e6ef2' },
  { name: '小飞机网盘', keywords: ['feijipan.com', 'feiji.cc'], color: '#00b4ff' },
  { name: '微云', keywords: ['weiyun.com'], color: '#4e6ef2' },
  { name: '曲奇云盘', keywords: ['quqi.com'], color: '#ff6600' },
  { name: '坚果云', keywords: ['jianguoyun.com', 'nutstore.net'], color: '#2d8cf0' },
  { name: 'Mega', keywords: ['mega.nz', 'mega.co.nz'], color: '#d92323' },
  { name: 'MediaFire', keywords: ['mediafire.com'], color: '#1a75ff' },
  { name: 'Dropbox', keywords: ['dropbox.com', 'dropboxusercontent.com'], color: '#0061ff' },
  { name: 'Google Drive', keywords: ['drive.google.com', 'docs.google.com'], color: '#4285f4' },
  { name: 'OneDrive', keywords: ['1drv.com', 'onedrive.live.com'], color: '#0078d4' },
  { name: 'Box', keywords: ['box.com', 'box.net'], color: '#0061ff' },
  { name: 'WeTransfer', keywords: ['wetransfer.com'], color: '#0075ff' },
  { name: 'GitHub', keywords: ['github.com', 'github.io'], color: '#24292e' },
  { name: 'GitLab', keywords: ['gitlab.com'], color: '#fc6d26' },
  { name: 'Gitee', keywords: ['gitee.com'], color: '#c71d23' },
  { name: 'Bitbucket', keywords: ['bitbucket.org'], color: '#0052cc' },
  { name: 'Steam', keywords: ['store.steampowered.com', 'steamcdn.com'], color: '#1b2838' },
  { name: 'App Store', keywords: ['apps.apple.com', 'itunes.apple.com'], color: '#0d84ff' },
  { name: 'Google Play', keywords: ['play.google.com'], color: '#01875f' },
];

function detectType(href) {
  for (const t of NETDISK_TYPES) {
    for (const kw of t.keywords) {
      if (href.indexOf(kw) !== -1) return t;
    }
  }
  return null;
}

/* ============ 设置读取 ============ */
function readSettings() {
  const def = { enabled: '1', show_bar: '1', stats: '1', report: '1', dedup_minutes: '5', btn_text: '下载' };
  try {
    const data = app.data || {};
    const attrs = (data.resources && data.resources[0] && data.resources[0].attributes) || data.attributes || {};
    const settings = data.settings || {};
    const get = (key) => {
      const v = attrs['djzycc-panbox.' + key] != null ? attrs['djzycc-panbox.' + key] : (settings['djzycc-panbox.' + key] != null ? settings['djzycc-panbox.' + key] : null);
      return v != null ? String(v) : null;
    };
    return {
      enabled: get('enabled') || def.enabled,
      show_bar: get('show_bar') || def.show_bar,
      stats: get('stats') || def.stats,
      report: get('report') || def.report,
      dedup_minutes: get('dedup_minutes') || def.dedup_minutes,
      btn_text: get('btn_text') || def.btn_text,
    };
  } catch (e) {
    return def;
  }
}

/* ============ 提取码识别 ============ */
function extractCodes(root) {
  const codes = [];
  const text = root.textContent || '';
  const re = /提取码[:：]\s*([A-Za-z0-9]{2,10})/g;
  let m;
  while ((m = re.exec(text)) !== null) codes.push(m[1]);
  return codes;
}

/* ============ 复制 ============ */
function copyText(text) {
  const fallback = () => {
    try {
      const ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      const ok = document.execCommand('copy');
      document.body.removeChild(ta);
      return ok;
    } catch (e) {
      return false;
    }
  };
  if (navigator.clipboard && window.isSecureContext) {
    return navigator.clipboard.writeText(text).then(() => true, fallback);
  }
  return Promise.resolve(fallback());
}

function flash(btn, okText) {
  const old = btn.textContent;
  btn.textContent = okText;
  btn.disabled = true;
  setTimeout(() => {
    btn.textContent = old;
    btn.disabled = false;
  }, 1200);
}

/* ============ API 调用 ============ */
function apiPost(url, body) {
  return fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
    credentials: 'same-origin',
  }).then((r) => r.json()).catch(() => ({}));
}

function apiGet(url) {
  return fetch(url, { credentials: 'same-origin' }).then((r) => r.json()).catch(() => ({}));
}

/* ============ 渲染下载栏 ============ */
function buildBar(postBody, discussionId, settings) {
  // 提取网盘链接
  const items = [];
  postBody.querySelectorAll('a[href]').forEach((a) => {
    const href = a.getAttribute('href') || '';
    const type = detectType(href);
    if (type) {
      items.push({ href, type, label: (a.textContent || '').trim() || type.name });
    }
  });
  if (!items.length) return null;

  const codes = extractCodes(postBody);

  const bar = document.createElement('div');
  bar.className = 'pb-download-bar open';

  // 头部
  const header = document.createElement('div');
  header.className = 'pb-bar-header';
  header.innerHTML = '<span class="pb-bar-title">下载资源</span><span class="pb-bar-toggle">展开 <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 9l6 6 6-6"/></svg></span>';
  bar.appendChild(header);

  // 内容区
  const body = document.createElement('div');
  body.className = 'pb-bar-body';

  const grid = document.createElement('div');
  grid.className = 'pb-download-buttons';

  items.forEach((it, idx) => {
    const key = md5(it.href).replace(/[^a-zA-Z0-9]/g, '').slice(0, 32);
    const card = document.createElement('a');
    card.className = 'pb-card';
    card.style.background = it.type.color;
    card.href = it.href;
    card.target = '_blank';
    card.rel = 'noopener nofollow';
    card.setAttribute('data-key', key);
    card.setAttribute('data-url', it.href);
    card.setAttribute('data-name', it.type.name);

    card.innerHTML =
      '<span class="pb-card-name">' + it.type.name + '</span>' +
      (codes[idx] ? '<span class="pb-card-passwd">' + codes[idx] + '</span>' : '<span class="pb-card-nopasswd">无提取码</span>') +
      (settings.stats === '1' ? '<span class="pb-card-count">-- 次下载</span>' : '');

    card.addEventListener('click', (e) => {
      e.preventDefault();
      // 统计上报
      if (settings.stats === '1' && discussionId > 0) {
        apiPost(app.forum.attribute('apiUrl') + '/panbox/download', {
          discussion_id: discussionId,
          link_key: key,
          url: it.href,
        });
      }
      window.open(it.href, '_blank', 'noopener');
      // 失效检测（轻量）
      apiGet(app.forum.attribute('apiUrl') + '/panbox/check?url=' + encodeURIComponent(it.href) + '&discussion_id=' + discussionId + '&link_key=' + key);
    });
    grid.appendChild(card);

    // 举报按钮
    if (settings.report === '1') {
      const rep = document.createElement('button');
      rep.type = 'button';
      rep.className = 'pb-report-btn';
      rep.textContent = '链接失效';
      rep.addEventListener('click', (e) => {
        e.stopPropagation();
        apiPost(app.forum.attribute('apiUrl') + '/panbox/report', {
          discussion_id: discussionId,
          link_key: key,
        }).then(() => flash(rep, '已举报'));
      });
      card.appendChild(rep);
    }
  });

  body.appendChild(grid);
  bar.appendChild(body);

  // 折叠切换
  header.addEventListener('click', () => {
    bar.classList.toggle('open');
  });

  // 拉取统计
  if (settings.stats === '1' && discussionId > 0) {
    apiGet(app.forum.attribute('apiUrl') + '/panbox/stats?discussion_id=' + discussionId).then((res) => {
      if (res && res.stats) {
        grid.querySelectorAll('.pb-card').forEach((card) => {
          const key = card.getAttribute('data-key');
          const count = res.stats[key] || 0;
          const el = card.querySelector('.pb-card-count');
          if (el) el.textContent = count + ' 次下载';
        });
      }
    });
  }

  return bar;
}

/* ============ 扫描注入 ============ */
function scanAndInject() {
  const settings = readSettings();
  if (settings.enabled !== '1') return;
  document.querySelectorAll('.Post-body').forEach((body) => {
    if (body.querySelector('.pb-download-bar')) return;
    // 尝试从 DOM 上下文找 discussion id
    let discussionId = 0;
    const post = body.closest('.Post');
    if (post) {
      const idAttr = post.getAttribute('data-id') || '';
      const m = idAttr.match(/(\d+)/);
      if (m) discussionId = parseInt(m[1], 10);
    }
    const bar = buildBar(body, discussionId, settings);
    if (bar) {
      body.insertBefore(bar, body.firstChild);
    }
  });
}

/* ============ md5 (轻量实现) ============ */
function md5(str) {
  // 极简哈希，仅用于生成稳定 key（后端 md5 对齐非必须，key 取 url 哈希即可）
  let h = 5381;
  for (let i = 0; i < str.length; i++) {
    h = ((h << 5) + h + str.charCodeAt(i)) | 0;
  }
  return (h >>> 0).toString(16);
}

app.initializers.add('djzycc-panbox', function () {
  const settings = readSettings();
  if (settings.enabled !== '1') return;

  scanAndInject();
  const observer = new MutationObserver(() => {
    clearTimeout(observer._t);
    observer._t = setTimeout(scanAndInject, 400);
  });
  observer.observe(document.body, { childList: true, subtree: true });
});
